import {
  fetchMinimumStock,
  fetchMultipleArticles,
  fetchMultipleProducts,
  fetchProduct,
  fetchProductActionLogs,
  fetchProductStock,
  fetchProducts,
  fetchProductsXlsx,
  importProductsXlsx,
} from '../queries/products.queries'

import { skipToken, useMutation, useQuery } from '@tanstack/react-query'

export const useProducts = () =>
  useQuery({
    queryKey: ['products'],
    queryFn: fetchProducts,
  })

export const useProduct = (id: number) =>
  useQuery({
    queryKey: ['product', id],
    queryFn: Number.isNaN(id) || id === 0 ? skipToken : () => fetchProduct(id),
  })

export const useMultipleProducts = (ids: number[]) =>
  useQuery({
    queryKey: ['multipleProducts', ids],
    queryFn: () => {
      if (ids.length === 0) {
        return []
      }
      return fetchMultipleProducts(ids)
    },
  })

export const useMinimumStock = (id: number) =>
  useQuery({
    queryKey: ['minimumStock', id],
    queryFn: Number.isNaN(id) || id === 0 ? skipToken : () => fetchMinimumStock(id),
  })

export const useMultipleArticles = (ids: string[] | null | undefined) =>
  useQuery({
    queryKey: ['multipleArticles', ids],
    queryFn: () => {
      if (!ids) {
        return []
      }
      if (ids.length === 0) {
        return []
      }
      return fetchMultipleArticles(ids)
    },
  })

export const useProductStock = (reference: string) =>
  useQuery({
    queryKey: ['productStock', reference],
    queryFn: () => {
      if (!reference) {
        return null
      }
      return fetchProductStock(reference)
    },
  })

export const useExportProductsXlsx = () =>
  useMutation({
    mutationFn: fetchProductsXlsx,
  })

export const useImportProductsXlsx = () =>
  useMutation({
    mutationFn: importProductsXlsx,
  })

export const useProductActionLogs = (productId?: number) =>
  useQuery({
    queryKey: ['product-action-logs', productId],
    queryFn: productId ? () => fetchProductActionLogs(productId) : skipToken,
  })
